import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    scrollableContainer: {
      position: "relative",
      margin: "0 -24px",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        margin: "0 -16px"
      }
    },
    contentContainer: {
      height: "calc(100vh - 196px)",
      overflowY: "auto",
      padding: "0 24px"
    },
    entry: {
      paddingTop: 20,
      "&:first-child": {
        paddingTop: 14
      }
    },
    headerDate: {
      color: "#2d2d2d",
      fontWeight: 700,
      marginBottom: 8
    },
    workoutSummary: {
      display: "flex",
      justifyContent: "space-between"
    },
    workoutFacility: {
      color: primary.dark,
      fontSize: 12,
      textTransform: "capitalize"
    },
    workoutDetails: {
      display: "flex",
      alignItems: "center",
      fontSize: 12,
      color: "#2d2d2d"
    },
    workout: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 12px 0 10px",
      border: "1px solid #ddd",
      minHeight: 34
    },
    ppsEntry: {
      display: "flex",
      padding: "10px 18px",
      justifyContent: "space-between",
      alignItems: "center",
      borderLeft: "1px solid #ddd",
      borderRight: "1px solid #ddd",
      borderBottom: "1px solid #ddd",
      wordBreak: "break-all",
      "&:first-child": {
        borderTop: "1px solid #ddd",
        paddingTop: 14,
        marginTop: 20
      },
      "&:nth-child(even)": {
        backgroundColor: "#f6f6f6"
      }
    },
    mediaPlayButton: {
      minWidth: 54,
      display: "flex",
      justifyContent: "end"
    },
    noResults: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#c3c3c3",
      textTransform: "capitalize"
    },
    nextPageFetchingLoader: {
      position: "absolute",
      width: 200,
      height: 100,
      left: "calc(50% - 100px)",
      bottom: 0
    },
    hidden: {
      display: "none"
    }
  };
});
